
export const isPublicRoute = (
  pathname: string,
  publicRoutes: Record<string, string>
): boolean => {
  return Object.values(publicRoutes).includes(pathname);
};

export const isNotFoundRoute = (
  pathname: string,
  publicRoutes: Record<string, string>,
  protectedRoutes: Record<string, string>
): boolean => {
  // Check if it's a public route first
  if (Object.values(publicRoutes).includes(pathname)) {
    return false;
  }
  
  // Check if it matches any protected route pattern
  const protectedRouteValues = Object.values(protectedRoutes);
  const matchesProtectedRoute = protectedRouteValues.some(routePattern => {
    // Convert route pattern to regex for matching
    const regexPattern = routePattern.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${regexPattern}$`);
    return regex.test(pathname);
  });
  
  return !matchesProtectedRoute;
};